// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wt-8";
export var editMode = "_wt-3";
export var headerRow = "_wt-a";
export var headerTitle = "_wt-b";
export var product = "_wt-1";
export var productDetails = "_wt-5";
export var productDivider = "_wt-7";
export var productImage = "_wt-2";
export var productInfo = "_wt-4";
export var productTitle = "_wt-6";
export var strikethrough = "_wt-9";
export var upsellProductsCard = "_wt-0";